import React from 'react';
import { TextareaField, Label, Icon } from '@printdeal/ui-library';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { messages as fieldTranslations } from '../../../../translations/quoteProductField';

interface DescriptionFieldProps {
  dispatchDataLayerEvent: (field: string, value: 'click' | 'fill' | 'empty') => void;
}

const REQUIRED_QUOTE_DETAILS = [
  {
    id: 'account.quotes.form.list.amount',
    content: <FormattedMessage id="account.quotes.form.list.amount" defaultMessage="Amount" />,
  },
  {
    id: 'account.quotes.form.list.size',
    content: <FormattedMessage id="account.quotes.form.list.size" defaultMessage="Size" />,
  },
  {
    id: 'account.quotes.form.list.finishing',
    content: <FormattedMessage id="account.quotes.form.list.finishing" defaultMessage="Finishing" />,
  },
  {
    id: 'account.quotes.form.list.material',
    content: <FormattedMessage id="account.quotes.form.list.material" defaultMessage="Material" />,
  },
];

const DescriptionField = ({ dispatchDataLayerEvent }: DescriptionFieldProps) => {
  const { register, formState: { errors } } = useFormContext();
  const intl = useIntl();

  return (
    <div className="pd-flex pd-items-start pd-gap-6">
      <TextareaField
        id="description"
        label={intl.formatMessage(fieldTranslations.descriptionLabel)}
        description={intl.formatMessage(fieldTranslations.descriptionDescription)}
        validation={errors.description ? 'error' : undefined}
        rows={10}
        required
        requiredLabel={intl.formatMessage({ id: 'general.form.requiredLabel', defaultMessage: 'Required field' })}
        {...register('description')}
        onBlur={(event) => dispatchDataLayerEvent('description', event.target.value ? 'fill' : 'empty')}
        onFocus={() => dispatchDataLayerEvent('description', 'click')}
        className="pd-max-w-lg pd-flex-1 pd-grow"
      />

      <div className="pd-flex pd-w-1/4 pd-flex-col pd-gap-2 pd-text-sm">
        <Label>
          <FormattedMessage
            id="account.quotes.form.list.heading"
            defaultMessage="To process your quote quickly, we need at least the following in your request:"
          />
        </Label>

        <ul className="pd-flex pd-flex-col pd-gap-2">
          {REQUIRED_QUOTE_DETAILS.map((item) => (
            <li key={item.id} className="pd-flex pd-items-center pd-gap-2">
              <Icon icon="check-orange" className="pd-h-4 pd-w-4" />
              {item.content}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DescriptionField;
